import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as actions from './settings.actions';
import { auth } from '../auth/auth.selectors';
import { NotificationsService } from '@careapp-group/ng-sdk';

@Injectable()
export class SettingsEffects {
  getNotificationPreferences = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestNotificationPreferencesAction),
      withLatestFrom(this.store.select(auth.getLoggedInUser)),
      filter(([action, user]) => !!user),
      switchMap(([action, user]) =>
        this.notificationsService.getNotificationPreferences({ id: user.id }).pipe(
          map((prefs) => actions.ResponseSuccessNotificationPreferencesAction({ payload: prefs })),
          catchError((err) => of(actions.ResponseFailNotificationPreferencesAction(err)))
        )
      )
    )
  );

  updateNotificationPreferences = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.RequestUpdateNotificationPreferencesAction),
      withLatestFrom(this.store.select(auth.getLoggedInUser)),
      switchMap(([action, user]) =>
        this.notificationsService
          .setNotificationPreferences({
            id: user.id,
            setNotificationPreferencesDto: action.payload,
          })
          .pipe(
            map((prefs) =>
              actions.ResponseSuccessUpdateNotificationPreferencesAction({ payload: prefs })
            ),
            catchError((err) =>
              of(actions.ResponseFailUpdateNotificationPreferencesAction({ payload: err }))
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private notificationsService: NotificationsService,
    private store: Store<any>
  ) {}
}
